import React from 'react';
import { TableContainer } from '@app/pages/facts/styles';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBinLine } from 'react-icons/ri';
import moment from 'moment';

const HealthConditionsTable = ({ health, handleDelete, handleEdit }) => {
  const head = ['Name', 'Type', 'Description', 'Date', ''];
  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {head.map((data, idx) => (
              <th key={idx}>{data}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {health.map((data) => (
            <tr key={data._id}>
              <td>{data.name}</td>
              <td>{data.type}</td>
              <td>{data.description || 'N/A'}</td>
              <td>{moment(data.created_at).format('LL')}</td>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: '26px' }}>
                  <CiEdit size={18} onClick={() => handleEdit(data)} />
                  <RiDeleteBinLine
                    size={18}
                    onClick={() => handleDelete(data._id)}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default HealthConditionsTable;
